import styled from "styled-components";
import { Text } from "../Text";

export const EntryGroupTitle = styled(Text.Heading3).attrs({ weight: "600" })`
  color: ${({ theme }) => theme.color.additional.dark.value};
`;
